/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React, { ChangeEvent } from 'react';
import { Checkbox } from '@sede-enterprise/shell-ds-react-framework';
import { ICheckboxProps } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Checkbox/Checkbox.types';
import { Controller, UseControllerProps } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import { IMemoisedComponentProp } from '../../types/Common.type';

interface IToggleControl extends IMemoisedComponentProp {
  controllerProps: UseControllerProps;
  label: string;
  handleOnChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checkboxProps?: ICheckboxProps;
}

const FormControlCheckbox: React.FC<IToggleControl> = ({
  methods,
  controllerProps,
  label,
  handleOnChange,
  checkboxProps,
}) => {
  const {
    formState: { errors },
    control,
  } = methods;
  const { name } = controllerProps;
  const errorMessage = errors?.[name]?.message;

  return (
    <>
      <Controller
        control={control}
        {...controllerProps}
        render={({ field: { onChange, value } }) => (
          <Checkbox
            label={label}
            onChange={(val) => {
              if (handleOnChange) {
                handleOnChange(val);
              }
              onChange(val);
            }}
            checked={value}
            {...checkboxProps}
            data-testid={name}
          />
        )}
      />
      {errorMessage && <ErrorMessage>{errorMessage as string}</ErrorMessage>}
    </>
  );
};
export default FormControlCheckbox;
